import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
    getDiscountPrice2,
    getProductCartQuantity,
} from "../../helpers/product";
import Rating from "./sub-components/ProductRating";
import { addToCart } from "../../store/slices/cart-slice";
import {
    addToWishlist,
    deleteFromWishlist,
} from "../../store/slices/wishlist-slice";
import { addToCompare } from "../../store/slices/compare-slice";
import {
    getVariantOptions,
    toastMessage,
    toastSuccess,
} from "../../helpers/utils";
import useLang from "../../hooks/use-lang";
import { useTranslation } from "react-i18next";

const ProductDescriptionInfo = ({
    product,
    selectedVariant,
    setSelectedVariant,
    // discountedPrice,
    currency,
    // finalDiscountedPrice,
    // finalProductPrice,
    cartItems,
    wishlistItem,
    compareItem,
}) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { getLangValue, getFlagValue } = useLang();
    const [selectedProductColor, setSelectedProductColor] = useState(
        product.variation ? product.variation[0].color : ""
    );
    const [selectedProductSize, setSelectedProductSize] = useState(
        product.variation ? product.variation[0].size[0].name : ""
    );
    // const [productStock, setProductStock] = useState(
    //     product.variation ? product.variation[0].size[0].stock : product.stock
    // );

    const { variant_option_1, variant_option_2, variant_option_3 } =
        getVariantOptions(product.variants);

    const [productStock, setProductStock] = useState(
        product.variants?.length > 0
            ? product.variants[0].inventory
            : product.inventory
    );

    const [selectedOption1, setSelectedOption1] = useState(
        variant_option_1?.options?.[0] || null
    );
    const [selectedOption2, setSelectedOption2] = useState(
        variant_option_2?.options?.[0] || null
    );
    const [selectedOption3, setSelectedOption3] = useState(
        variant_option_3?.options?.[0] || null
    );

    // const [selectedOption1, setSelectedOption1] = useState(product.variants ? product.variants[0])
    const [quantityCount, setQuantityCount] = useState(1);

    const productCartQty = getProductCartQuantity(
        cartItems,
        product,
        selectedProductColor,
        selectedProductSize,
        selectedVariant
    );

    const discountedPrice = getDiscountPrice2(
        selectedVariant?.sale_price,
        selectedVariant?.discount
    );
    const finalProductPrice = +(
        selectedVariant?.retail_price * currency.currencyRate
    ).toFixed(2);
    const finalDiscountedPrice = +(
        discountedPrice * currency.currencyRate
    ).toFixed(2);

    let dimensions = "";
    if (
        selectedVariant &&
        selectedVariant.width_cm &&
        selectedVariant.height_cm &&
        selectedVariant.depth_cm
    ) {
        dimensions = `${selectedVariant.width_cm} cm x ${selectedVariant.height_cm} cm x ${selectedVariant.depth_cm} cm`;
    }
    let tasting_notes = getFlagValue(
        selectedVariant,
        "flag_6",
        "flag_7",
        "flag_7"
    );
    let item_subtitle = getFlagValue(
        selectedVariant,
        "flag_4",
        "flag_5",
        "flag_5"
    );

    const copyToClipboard = (link) => {
        navigator.clipboard
            .writeText(link)
            .then(() => {
                // Optional: Display a message or perform an action after successful copying
                toastMessage(t("product__copied_share_url"), "success");
            })
            .catch((err) => {
                // Handle any errors
                console.error("Failed to copy: ", err);
            });
    };

    useEffect(() => {
        if (!product.variants || product.variants.length === 0) return;
        let _selectedVariant = product.variants.find((v) => {
            return (
                v.variant_value_1_en === (selectedOption1?.value_en || null) &&
                (!v.variant_value_2_en ||
                    v.variant_value_2_en ===
                    (selectedOption2?.value_en || null)) &&
                (!v.variant_value_3_en ||
                    v.variant_value_3_en ===
                    (selectedOption3?.value_en || null))
            );
        });

        setSelectedVariant(_selectedVariant);
        setProductStock(_selectedVariant?.inventory || 0);
    }, [product, setSelectedVariant, selectedOption1, selectedOption2, selectedOption3]);

    useEffect(() => {
        setSelectedOption1(variant_option_1?.options?.[0] || null);
        setSelectedOption2(variant_option_2?.options?.[0] || null);
        setSelectedOption3(variant_option_3?.options?.[0] || null);
    }, [product])

    console.log('selectedVariant', selectedVariant);

    return (
        <div className="product-details-content ml-70">
            <h2>{getLangValue(product, "product_name")}</h2>
            <div className="product-details-price">
                {discountedPrice !== null ? (
                    <Fragment>
                        <span>
                            {currency.currencySymbol + finalDiscountedPrice}
                        </span>{" "}
                        <span className="old">
                            {currency.currencySymbol + finalProductPrice}
                        </span>
                    </Fragment>
                ) : (
                    <span>{currency.currencySymbol + finalProductPrice} </span>
                )}
            </div>
            {product.rating && product.rating > 0 ? (
                <div className="pro-details-rating-wrap">
                    <div className="pro-details-rating">
                        <Rating ratingValue={product.rating} />
                    </div>
                </div>
            ) : (
                ""
            )}

            {variant_option_1 && (
                <div className="pro-details-size-color">
                    <div className="pro-details-size">
                        <span>{getLangValue(variant_option_1, "name")}</span>
                        <div className="pro-details-size-content">
                            {variant_option_1.options.map((option, key) => {
                                return (
                                    <label
                                        className={`pro-details-size-content--single`}
                                        key={key}
                                    >
                                        <input
                                            type="radio"
                                            value={option}
                                            checked={
                                                option?.value_en ===
                                                    selectedOption1?.value_en
                                                    ? "checked"
                                                    : ""
                                            }
                                            onChange={() => {
                                                setSelectedOption1(option);
                                                setQuantityCount(1);
                                            }}
                                        />
                                        <span className="size-name">
                                            {getLangValue(option, "value")}
                                        </span>
                                    </label>
                                );
                            })}
                        </div>
                    </div>
                </div>
            )}
            {variant_option_2 && (
                <div className="pro-details-size-color mt-2">
                    <div className="pro-details-size">
                        <span>{getLangValue(variant_option_2, "name")}</span>
                        <div className="pro-details-size-content">
                            {variant_option_2.options.map((option, key) => {
                                return (
                                    <label
                                        className={`pro-details-size-content--single`}
                                        key={key}
                                    >
                                        <input
                                            type="radio"
                                            value={option}
                                            checked={
                                                option?.value_en ===
                                                    selectedOption2?.value_en
                                                    ? "checked"
                                                    : ""
                                            }
                                            onChange={() => {
                                                setSelectedOption2(option);
                                                setQuantityCount(1);
                                            }}
                                        />
                                        <span className="size-name">
                                            {getLangValue(option, "value")}
                                        </span>
                                    </label>
                                );
                            })}
                        </div>
                    </div>
                </div>
            )}
            {variant_option_3 && (
                <div className="pro-details-size-color mt-2">
                    <div className="pro-details-size">
                        <span>{getLangValue(variant_option_3, "name")}</span>
                        <div className="pro-details-size-content">
                            {variant_option_3.options.map((option, key) => {
                                return (
                                    <label
                                        className={`pro-details-size-content--single`}
                                        key={key}
                                    >
                                        <input
                                            type="radio"
                                            value={option}
                                            checked={
                                                option?.value_en ===
                                                    selectedOption3?.value_en
                                                    ? "checked"
                                                    : ""
                                            }
                                            onChange={() => {
                                                setSelectedOption3(option);
                                                setQuantityCount(1);
                                            }}
                                        />
                                        <span className="size-name">
                                            {getLangValue(option, "value")}
                                        </span>
                                    </label>
                                );
                            })}
                        </div>
                    </div>
                </div>
            )}

            <div className="description-review-bottom">
                <div className="product-anotherinfo-wrapper">
                    <ul>
                        {selectedVariant?.actual_weight_kg && (
                            <li>
                                <span>{t("product__net_weight")}</span>{" "}
                                {selectedVariant?.actual_weight_kg || ""} kg
                            </li>
                        )}
                        {selectedVariant?.shipping_weight_kg && (
                            <li>
                                <span>{t("product__gross_weight")}</span>{" "}
                                {selectedVariant?.shipping_weight_kg || ""} kg
                            </li>
                        )}
                        {dimensions && (
                            <li>
                                <span>{t("product__dimensions")}</span>{" "}
                                {dimensions}
                            </li>
                        )}
                        {selectedVariant?.expiration_date && (
                            <li>
                                <span>{t("product__expiration")}</span>{" "}
                                {selectedVariant.expiration_date}
                            </li>
                        )}
                        {item_subtitle && (
                            <li>
                                <span>{t("product__item_subtitle")}</span>{" "}
                                {item_subtitle}
                            </li>
                        )}
                        {tasting_notes && (
                            <li>
                                <span>{t("product__tasting_notes")}</span>{" "}
                                {tasting_notes}
                            </li>
                        )}
                    </ul>
                </div>
            </div>

            <div className="pro-details-list">
                <p
                    dangerouslySetInnerHTML={{
                        __html: getLangValue(product, "product_description"),
                    }}
                ></p>
            </div>

            {product.variation ? (
                <div className="pro-details-size-color">
                    <div className="pro-details-color-wrap">
                        <span>Color</span>
                        <div className="pro-details-color-content">
                            {product.variation.map((single, key) => {
                                return (
                                    <label
                                        className={`pro-details-color-content--single ${single.color}`}
                                        key={key}
                                    >
                                        <input
                                            type="radio"
                                            value={single.color}
                                            name="product-color"
                                            checked={
                                                single.color ===
                                                    selectedProductColor
                                                    ? "checked"
                                                    : ""
                                            }
                                            onChange={() => {
                                                setSelectedProductColor(
                                                    single.color
                                                );
                                                setSelectedProductSize(
                                                    single.size[0].name
                                                );
                                                setProductStock(
                                                    single.size[0].stock
                                                );
                                                setQuantityCount(1);
                                            }}
                                        />
                                        <span className="checkmark"></span>
                                    </label>
                                );
                            })}
                        </div>
                    </div>
                    <div className="pro-details-size">
                        <span>Size</span>
                        <div className="pro-details-size-content">
                            {product.variation &&
                                product.variation.map((single) => {
                                    return single.color === selectedProductColor
                                        ? single.size.map((singleSize, key) => {
                                            return (
                                                <label
                                                    className={`pro-details-size-content--single`}
                                                    key={key}
                                                >
                                                    <input
                                                        type="radio"
                                                        value={
                                                            singleSize.name
                                                        }
                                                        checked={
                                                            singleSize.name ===
                                                                selectedProductSize
                                                                ? "checked"
                                                                : ""
                                                        }
                                                        onChange={() => {
                                                            setSelectedProductSize(
                                                                singleSize.name
                                                            );
                                                            setProductStock(
                                                                singleSize.stock
                                                            );
                                                            setQuantityCount(
                                                                1
                                                            );
                                                        }}
                                                    />
                                                    <span className="size-name">
                                                        {singleSize.name}
                                                    </span>
                                                </label>
                                            );
                                        })
                                        : "";
                                })}
                        </div>
                    </div>
                </div>
            ) : (
                ""
            )}
            {product.affiliateLink ? (
                <div className="pro-details-quality">
                    <div className="pro-details-cart btn-hover ml-0">
                        <a
                            href={product.affiliateLink}
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            Buy Now
                        </a>
                    </div>
                </div>
            ) : (
                <div className="pro-details-quality">
                    <div className="cart-plus-minus">
                        <button
                            onClick={() =>
                                setQuantityCount(
                                    quantityCount > 1 ? quantityCount - 1 : 1
                                )
                            }
                            className="dec qtybutton"
                        >
                            -
                        </button>
                        <input
                            className="cart-plus-minus-box"
                            type="text"
                            value={quantityCount}
                            readOnly
                        />
                        <button
                            onClick={() =>
                                setQuantityCount(
                                    quantityCount <
                                        productStock - productCartQty
                                        ? quantityCount + 1
                                        : quantityCount
                                )
                            }
                            className="inc qtybutton"
                        >
                            +
                        </button>
                    </div>
                    <div className="pro-details-cart btn-hover">
                        {productStock && productStock > 0 ? (
                            <button
                                onClick={() =>
                                    dispatch(
                                        addToCart({
                                            ...product,
                                            quantity: quantityCount,
                                            selectedProductColor:
                                                selectedProductColor
                                                    ? selectedProductColor
                                                    : product.selectedProductColor
                                                        ? product.selectedProductColor
                                                        : null,
                                            selectedProductSize:
                                                selectedProductSize
                                                    ? selectedProductSize
                                                    : product.selectedProductSize
                                                        ? product.selectedProductSize
                                                        : null,
                                            ...selectedVariant,
                                        })
                                    )
                                }
                                disabled={productCartQty >= productStock}
                                className="gtm-add_to_cart"
                                data-sku={selectedVariant.product_sku}
                                data-name={getLangValue(selectedVariant, "product_name")}
                                data-price={selectedVariant.sale_price}
                            >
                                {t("shop__add_to_cart")}
                            </button>
                        ) : (
                            <button disabled>{t("shop__out_of_stock")}</button>
                        )}
                    </div>
                    <div className="pro-details-wishlist">
                        <button
                            className={
                                wishlistItem !== undefined ? "active" : ""
                            }
                            disabled={wishlistItem !== undefined && false}
                            title={
                                wishlistItem !== undefined
                                    ? "Added to wishlist"
                                    : "Add to wishlist"
                            }
                            onClick={() => {
                                if (wishlistItem) {
                                    dispatch(
                                        deleteFromWishlist(wishlistItem.id)
                                    );
                                } else {
                                    dispatch(addToWishlist(product));
                                }
                            }}
                        >
                            <i
                                className={`fa ${wishlistItem !== undefined
                                        ? "fa-heart"
                                        : "fa-heart-o"
                                    }`}
                            />
                        </button>
                    </div>
                    {/* <div className="pro-details-compare">
            <button
              className={compareItem !== undefined ? "active" : ""}
              disabled={compareItem !== undefined}
              title={
                compareItem !== undefined
                  ? "Added to compare"
                  : "Add to compare"
              }
              onClick={() => dispatch(addToCompare(product))}
            >
              <i className="pe-7s-shuffle" />
            </button>
          </div> */}
                </div>
            )}
            {product.category ? (
                <div className="pro-details-meta">
                    <span>Categories :</span>
                    <ul>
                        {product.category.map((single, key) => {
                            return (
                                <li key={key}>
                                    <Link
                                        to={
                                            process.env.PUBLIC_URL +
                                            "/shop-grid-standard"
                                        }
                                    >
                                        {single}
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            ) : (
                ""
            )}
            {product.tag ? (
                <div className="pro-details-meta">
                    <span>Tags :</span>
                    <ul>
                        {product.tag.map((single, key) => {
                            return (
                                <li key={key}>
                                    <Link
                                        to={
                                            process.env.PUBLIC_URL +
                                            "/shop-grid-standard"
                                        }
                                    >
                                        {single}
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            ) : (
                ""
            )}

            <div className="pro-details-social">
                <ul>
                    <li>
                        <Link
                            to={`https://www.facebook.com/sharer.php?u=${encodeURIComponent(
                                window.location.href
                            )}`}
                            target="_blank"
                        >
                            <i className="fa fa-facebook" />
                        </Link>
                    </li>
                    <li>
                        <Link
                            to={`https://api.whatsapp.com/send?text=${encodeURIComponent(
                                window.location.href
                            )}`}
                            target="_blank"
                        >
                            <i className="fa fa-whatsapp" />
                        </Link>
                    </li>
                    <li>
                        <a
                            href="#"
                            onClick={(e) => {
                                e.preventDefault(); // Prevent default anchor action
                                copyToClipboard(window.location.href);
                            }}
                        >
                            <i className="fa fa-link" />
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    );
};

ProductDescriptionInfo.propTypes = {
    cartItems: PropTypes.array,
    compareItem: PropTypes.shape({}),
    currency: PropTypes.shape({}),
    discountedPrice: PropTypes.number,
    finalDiscountedPrice: PropTypes.number,
    finalProductPrice: PropTypes.number,
    product: PropTypes.shape({}),
    wishlistItem: PropTypes.shape({}),
};

export default ProductDescriptionInfo;
